import { makeStyles, Button } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import BackForwardButton from '../../Shared/BackForwardButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import OrderDetailProgressBar from '../../Order/OrderDetail/OrderDetailProgressBar';
import OrderDetailMainInfo from '../../Order/OrderDetail/OrderDetailMainInfo';
import OrderDetailMaterials from '../../Order/OrderDetail/OrderDetailMaterials';
import OrderDetailStatusBar from '../../Order/OrderDetail/OrderDetailStatus/OrderDetailStatusBar';
import { NavLink } from "react-router-dom";
import { dataService } from '../../../Services/data.service'
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import MachineParametersDrawer from '../../MachineParameters/MachineParametersDrawer';
import ManualReplenishmentDrawer from '../../ManualReplenishment/ManualReplenishmentDrawer';
import { toast } from 'react-toastify';
import MaterialCorrectionDrawer from '../../ManualReplenishment/MaterialCorrectionDrawer';
import DeleteDialog from '../../Shared/Dialogs/DeleteDialog';
import StandstillPopup from '../../Order/OrderDetail/OrderDetailStatus/StandstillPopup';
import StandstillCleaningPopup from '../../Order/OrderDetail/OrderDetailStatus/StandstillCleaningPopup';
import StandstillCleaningReasonDrawer from '../../Order/OrderDetail/OrderDetailStatus/StandstillCleaningReasonDrawer';
import StandstillTechnicalReasonPopup from '../../Order/OrderDetail/OrderDetailStatus/StandstillTechnicalReasonPopup';
import ScissorStateComponent from '../../Workstation/ScissorStateComponent';
import TableStateComponent from '../../Workstation/TableStateComponent';
import { productionOrderStates } from '../../../Config/productionOrderStates'
import { machineScissorZone, StandStillTypes } from '../../../Config/constants'
import { scissorTypes } from '../../../Config/scissorStates';
import { connect } from 'react-redux';
import { HubConnectionBuilder } from '@microsoft/signalr';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import ZoneDivisionPopup from '../../ZoneDivision/ZoneDivisionPopup';
import ZoneDivisionPopupInput from '../../ZoneDivision/ZoneDivisionPopupInput';
import { roles } from '../../../Config/authConstants';
import Box from '@mui/material/Box';

export const OrderDetailPage = (props) => {
    const classes = useStyles();

    const [order, setOrder] = useState(null);
    const [nextOrder, setNextOrder] = useState(null);
    const [zoneDivisionPopupInputOpen, setZoneDivisionPopupInputOpen] = useState(false);
    const [zoneDivisionPopupOpen, setZoneDivisionPopupOpen] = useState(false);
    const [standstillPopupOpen, setStandstillPopupOpen] = useState(false);
    const [standstillCleaningPopupOpen, setStandstillCleaningPopupOpen] = useState(false);
    const [standstillTechnicalPopupOpen, setStandstillTechnicalPopupOpen] = useState(false);
    const [standstillCleaningReasonPopupOpen, setStandstillCleaningReasonPopupOpen] = useState(false);
    const [machineParametersDrawerOpen, setMachineParametersDrawerOpen] = useState(false);
    const [manualReplenishmentDrawerOpen, setManualReplenishmentDrawerOpen] = useState(false);
    const [materialCorrectionDrawerOpen, setMaterialCorrectionDrawerOpen] = useState(false);
    const [deleteQuantitiesDialogOpen, setDeleteQuantitiesDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const [updateQuantityAtMachine, setUpdateQuantityAtMachine] = useState(false)
    const [quantitiesAssigned, setQuantitiesAssigned] = useState([])
    const [quantityIdToRemove, setQuantityIdToRemove] = useState(null)
    const [orderRefresh, setOrderRefresh] = useState(false)
    const [producedBOMOut, setProducedBOMOut] = useState(null)
    const [zones, setZones] = useState([])
    const [zoneDivisions, setZoneDivisions] = useState([])
    const [hasZoneDivisions, sethasZoneDivisions] = useState(null)
    const [zoneDivisionsOrderLineId, setZoneDivisionsOrderLineId] = useState(null)
    const [productionOrders, setProductionOrders] = useState([])
    const [bookingFeedbackDialogOpen, setBookingFeedbackDialogOpen] = useState(false)
    const [reload, setReload] = useState(false)
    const appSettings = props.appSettings;

    const { t } = useTranslation();
    let history = useHistory();

    useEffect(() => {

        setReload(false);

        Promise.all([
            dataService.getMachinesByMachineType(machineScissorZone),
            dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)),
            dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation),
            dataService.getProductionOrderLineStateHistory(parseInt(props.match.params.orderLineId)),
            dataService.getZoneDivisions(parseInt(props.match.params.orderLineId)),
        ]).then((results) => {
            let machines = results[0];
            let order = results[1];
            let orders = results[2];
            let orderLineHistory = results[3];
            let zoneDivisionsModel = results[4];
            if (order !== null) {
                dataService.getMachineInAssignedByMachineId(order.machineIdPlanned).then(machineInAssigned =>
                    setQuantitiesAssigned(machineInAssigned)
                )
                dataService.getProductionOrderLineBOMOutProducedByBOMOutId(order.bomOut[0].id).then(bomOutProduced =>
                    setProducedBOMOut(bomOutProduced)
                )

                //create time from this?
                let previouslyPaused = orderLineHistory.filter(x => x.productionOrderLineStatusId === 3).filter(x => x.finishedOn !== null);
                let paused = orderLineHistory.filter(x => x.productionOrderLineStatusId === 3).filter(x => x.finishedOn === null);
                let timePaused = 0;

                if (previouslyPaused.length > 0) {
                    previouslyPaused.map(x => {
                        var startedOn = new Date(x.startedOn);
                        var finishedOn = new Date(x.finishedOn);
                        var difference = Math.abs(finishedOn - startedOn);
                        timePaused = timePaused + difference;
                    });
                }

                if (paused.length > 0) {
                    paused.map(x => {
                        var startedOn = new Date(x.startedOn);
                        var finishedOn = new Date();
                        var difference = Math.abs(finishedOn - startedOn);
                        timePaused = timePaused + difference;
                    });
                }

                if (orderLineHistory.find(x => x.finishedOn === null)) {
                    order.startedOn = new Date(new Date(order.startedOn).getTime() + timePaused);
                }

                setZones(machines);
                setOrder(order);
                setProductionOrders(orders);

                setZoneDivisions(zoneDivisionsModel.zoneDivisionEntries);
                sethasZoneDivisions(zoneDivisionsModel.hasData);
                setZoneDivisionsOrderLineId(zoneDivisionsModel.orderLineId);

                if (order.productionOrderStatus !== productionOrderStates.STOPPED && order.productionOrderStatus !== productionOrderStates.DONE) {
                    orders = orders.filter(x => x.productionOrderStatus !== productionOrderStates.STOPPED && x.productionOrderStatus !== productionOrderStates.DONE);
                }
                else {
                    orders = orders.filter(x => x.productionOrderStatus === productionOrderStates.STOPPED || x.productionOrderStatus === productionOrderStates.DONE);
                }

                let index = orders.sort((a, b) => new Date(a.startedOnPlanned) - new Date(b.startedOnPlanned)).findIndex(x => x.id === order.id);
                if (index + 1 >= orders.length) {
                    setNextOrder(null);
                }
                else {
                    setNextOrder(orders[index + 1]);
                }
            }

        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }, [updateQuantityAtMachine, orderRefresh, props.workstationState, props.match.params.id, props.workstation.selectedWorkstation, reload]);

    useEffect(() => {
        const newBookingConnection = new HubConnectionBuilder()
            .withUrl(appSettings.IPB_SHOPFLOOR_BOOKING_HUB_URL)
            .withAutomaticReconnect()
            .build();
        newBookingConnection.on('ReceiveMessage', bookingFeedback => {
            if (parseInt(props.match.params.id) === bookingFeedback.productionOrderId) {
                setDialogTitle(t("Attention!"))
                let text = `Geen boeking in ERP voor pallet met barcode ${bookingFeedback.barcode} op order ${bookingFeedback.productionOrderReference}, reden: onvoldoende hoeveelheid materiaal!`
                setDialogContext(text)
                openBookingFeedbackDialog()
            }

        });
        newBookingConnection.start().then(() => {
            console.log('Booking hub connected!');
        }).catch(e => console.log('Booking hub connection failed: ', e));
        // eslint-disable-next-line
    }, [props.match.params.id]);

    // check for cleaning standstill
    // useEffect(() => {
    //     if (order) {
    //         let tempAllMachineStandStills = props.machineStandStill.machineStandStillInfo
    //         if (tempAllMachineStandStills.length > 0) {
    //             let tempMachineStandStill = tempAllMachineStandStills.find(x => x.machineId === order.machineIdPlanned)
    //             if (tempMachineStandStill) {
    //                 setStandstillCleaningReasonPopupOpen(true)
    //             }
    //         }
    //     }

    // }, [order])

    const removeStandStillFromRedux = () => {
        let tempAllMachineStandStills = props.machineStandStill.machineStandStillInfo;
        if (tempAllMachineStandStills.length > 0) {
            let tempMachineStandStill = tempAllMachineStandStills.find(x => x.machineId === order.machineIdPlanned);
            if (tempMachineStandStill) {
                // remove from redux
                let index = tempAllMachineStandStills.indexOf(tempMachineStandStill);
                tempAllMachineStandStills.splice(index, 1);
                props.actions.setMachineStandStillInfo(tempAllMachineStandStills);
            }
        }
    }

    const openZoneDivisionPopupInput = (open) => {
        setZoneDivisionPopupInputOpen(open);
    }

    const openZoneDivisionPopup = (open) => {
        setZoneDivisionPopupOpen(open);
    }

    const openStandstillPopup = () => {
        setStandstillPopupOpen(true);
    }

    const closeStandstillDialog = () => {
        setStandstillPopupOpen(false);
    }

    const confirmStandstillDialog = (radioValue) => {
        if (radioValue == 1) {
            setStandstillPopupOpen(false);
            setStandstillTechnicalPopupOpen(true);
        } else if (radioValue == 2) {
            setStandstillPopupOpen(false);
            dataService.LogStandStillStart(StandStillTypes.PLANNED, "", order.machinePlannedCode.match(/\d/g).join("")).then(() => setStandstillPopupOpen(false))
        } else if (radioValue == 3) {
            setStandstillPopupOpen(false);
            setStandstillCleaningPopupOpen(true);
        } else {
            setStandstillPopupOpen(false);
        }
    }

    const closeStandstillCleaningDialog = () => {
        setStandstillCleaningPopupOpen(false);
    }

    const confirmStandstillCleaningDialog = (checked, username, password) => {

        let roleArray = [roles.PLOEGCHEF, roles.ADMINISTRATOR];
        if (!checked) {
            dataService.validateAndHasRole(username, password, roleArray).then((result) => {
                if (result.succeeded) {
                    setStandstillCleaningPopupOpen(false);
                    setStandstillCleaningReasonPopupOpen(true);
                    dataService.LogStandStillStart(StandStillTypes.CLEANSTART, username, order.machinePlannedCode.match(/\d/g).join("")).then(() => setStandstillPopupOpen(false));
                }
                else {
                    toast.error(t("IncorrectCredentials"), { position: "top-center" });
                }
            }).catch((error) => { toast.error(error, { position: "top-center" }) });
        } else {
            setStandstillCleaningPopupOpen(false);
            setStandstillCleaningReasonPopupOpen(true);
            dataService.LogStandStillStart(StandStillTypes.CLEANSTART, "", order.machinePlannedCode.match(/\d/g).join("")).then(() => setStandstillPopupOpen(false))
        }
    }

    const confirmStandstillTechnicalDialog = (remark) => {
        dataService.LogStandStillStop(StandStillTypes.TECHNICAL, "", order.machinePlannedCode.match(/\d/g).join(""), "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", remark).then(() => setStandstillTechnicalPopupOpen(false))
    }

    const openStandstillCleaningReasonDialog = (open) => {
        setStandstillCleaningReasonPopupOpen(open);
    }

    const closeStandstillTechnicalReasonDialog = () => {
        setStandstillTechnicalPopupOpen(false);
    }

    const confirmStandstillCleaningReasonDialog = (checked, userName, password, nieuwefilter, reservefilter, kuisenfilter, gaatjes, reinigen, gaatjesVrijmaken, mondstuk, beentjes, gaatesUitstekken, lippen, elektroden, mesjes, uitvoerrollen, restenUithalen, opkuisMachine, reinigenSchema, remark) => {
        let roleArray = [roles.PLOEGCHEF, roles.ADMINISTRATOR];
        if (!checked) {
            dataService.validateAndHasRole(userName, password, roleArray).then((result) => {
                if (result.succeeded) {
                    removeStandStillFromRedux();
                    setStandstillCleaningReasonPopupOpen(false);
                    dataService.LogStandStillStop(StandStillTypes.CLEANSTOP, userName, order.machinePlannedCode.match(/\d/g).join(""), nieuwefilter, reservefilter, kuisenfilter, gaatjes, reinigen, gaatjesVrijmaken, mondstuk, beentjes, gaatesUitstekken, lippen, elektroden, mesjes, uitvoerrollen, restenUithalen, opkuisMachine, reinigenSchema, remark).then(() => setStandstillPopupOpen(false))
                }
                else {
                    toast.error(t("IncorrectCredentials"), { position: "top-center" })
                }
            }).catch((error) => { toast.error(error, { position: "top-center" }) })
        } else {
            setStandstillCleaningReasonPopupOpen(false);
            dataService.LogStandStillStop(StandStillTypes.CLEANSTOP, "", order.machinePlannedCode.match(/\d/g).join(""), nieuwefilter, reservefilter, kuisenfilter, gaatjes, reinigen, gaatjesVrijmaken, mondstuk, beentjes, gaatesUitstekken, lippen, elektroden, mesjes, uitvoerrollen, restenUithalen, opkuisMachine, reinigenSchema, remark).then(() => setStandstillPopupOpen(false))
        }
    }

    const openMachineParametersDrawer = (open) => {
        setMachineParametersDrawerOpen(open);
    }

    const openManualReplenishmentDrawer = (open) => {
        setManualReplenishmentDrawerOpen(open);
    }

    const openMaterialCorrectionDrawer = (open) => {
        setMaterialCorrectionDrawerOpen(open);
    }

    const updateOrderDetailPage = () => {
        setOrderRefresh(!orderRefresh)
    }

    const openDeleteQuantitiesDialog = (id) => {
        setQuantityIdToRemove(id)
        setDialogTitle("Delete")
        setDialogContext("Are you sure deleting this quantity?")
        setDeleteQuantitiesDialogOpen(true)
    }

    const deleteMaterialAssigned = (id) => {
        dataService.deleteMachineInAssignedById(id).then(
            setUpdateQuantityAtMachine(!updateQuantityAtMachine),

            refreshQuantitiesAssigned()
        ).catch((error) => { toast.error(error, { position: "top-center" }) })
        setDeleteQuantitiesDialogOpen(false)
    }

    const openBookingFeedbackDialog = () => {
        setBookingFeedbackDialogOpen(true)
    }

    const closeBookingFeedbackDialog = () => {
        setBookingFeedbackDialogOpen(false)
        setDialogTitle(null)
        setDialogContext(null)
    }

    const refreshQuantitiesAssigned = () => {
        dataService.getMachineInAssignedByMachineId(order.machineIdPlanned).then(assigned => {

            if (JSON.stringify(assigned) !== JSON.stringify(quantitiesAssigned)) {
                setQuantitiesAssigned(assigned)
            }

        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }

    const getQuantityAtMachine = (productId) => {
        let quantityAtMachine = 0;
        var i;
        for (i = 0; i < quantitiesAssigned.length; i++) {
            if (JSON.parse(quantitiesAssigned[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].ProductId === productId) {
                quantityAtMachine += quantitiesAssigned[i].quantityAssigned
            }
        }

        return quantityAtMachine;
    }

    const navigateToNextOrder = () => {

        if (nextOrder) {

            if (nextOrder.bowMetaData) {
                let metaData = JSON.parse(nextOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0]

                if (metaData.UsedZones.length > 0) {
                    props.actions.setSelectedZone(zones.find(x => x.id === metaData.UsedZones[0].ZoneId).name)
                }
            }
            else {
                props.actions.setSelectedZone(null)
            }

            history.push('/order/' + nextOrder.id + '/' + nextOrder.orderLineId);

        } else {
            if (order) {
                history.push('/order/' + order.id + '/' + order.orderLineId);
            }
        }
    }



    return (
        <div className={classes.background}>
            {order ? <React.Fragment>
                <div className={classes.main}>
                    <div className={classes.header}>
                        <div className={classes.title}>
                            <NavLink className={classes.navButton} to={`/workstation`}>
                                <BackForwardButton direction={'Back'} textOverride={t("Back to production queue")}></BackForwardButton>
                            </NavLink>
                            <div className={classes.orderNumber}>
                                {"Order " + order.reference}
                            </div>
                        </div>
                        {console.log(props.workstationState)}
                        {props.workstationState.workstationsWithScissorStatusInfo ?
                            props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)
                                ?
                                <div className={classes.scissorStatus}>
                                    <TableStateComponent size={"M"} machineNumber={order.machinePlannedCode.match(/\d/g).join("")} selectedWorkstation={props.workstation.selectedWorkstation} tableStatus={props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)}></TableStateComponent>
                                </div>
                                :
                                <div className={classes.scissorStatus}>
                                    <div className={classes.upperScissor}>
                                        <ScissorStateComponent size={"M"} machineNumber={order.machinePlannedCode.match(/\d/g).join("")} upper selectedWorkstation={props.workstation.selectedWorkstation}></ScissorStateComponent>
                                    </div>
                                    <div className={classes.lowerScissor}>
                                        <ScissorStateComponent size={"M"} machineNumber={order.machinePlannedCode.match(/\d/g).join("")} lower selectedWorkstation={props.workstation.selectedWorkstation}></ScissorStateComponent>
                                    </div>
                                </div> : <React.Fragment></React.Fragment>}
                    </div>
                    <div className={classes.body}>
                        <Box className={classes.upperBody} sx={{ display: "flex", flexDirection: { xs: 'column', md: 'row' }, minHeight: "120px", marginRight: "35px" }}>
                            <Box sx={{ height: "120px", backgroundColor: "white", boxShadow: "0px 3px 15px rgba(0,0,0,0.1)", borderRadius: "6px", float: "left", boxSizing: "border-box", marginRight: { xs: "0px", md: "0.7%" }, width: { xs: "100%" }, }}>
                                <div className={classes.productionProgress}>
                                    {t('Production progress (n° of palets)')}
                                </div>
                                <OrderDetailProgressBar producedBOMOut={producedBOMOut} productionOrder={order} {...props}></OrderDetailProgressBar>
                            </Box>
                            <Box sx={{ width: { xs: "100%", md: "40%" }, marginTop: { xs: '10px', md: '0px' }, border: "1px solid #DEDEDE", borderRadius: "6px", float: "left", boxSizing: "border-box", padding: "10px" }}>
                                <div className={classes.upNextHeader}>
                                    <div className={classes.titleUpNext}>
                                        {t('UpNext')}:
                                    </div>{nextOrder !== null &&
                                        <div className={classes.viewDetailsButton}>
                                            <Button onClick={() => navigateToNextOrder()}>
                                                <div className={classes.viewDetails}>
                                                    {t('ViewDetails')}
                                                </div>
                                                <ArrowForwardIosIcon className={classes.arrowForward}></ArrowForwardIosIcon>
                                            </Button>
                                        </div>
                                    }
                                </div>
                                <div className={classes.timeNextOrder}>
                                    <div className={classes.timeSvg}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" className="__web-inspector-hide-shortcut__"><defs></defs><path className="a" fill="#8d8d8d" fillRule="evenodd" d="M2.2,2.2A7.224,7.224,0,0,1,7.5,0a7.224,7.224,0,0,1,5.3,2.2A7.224,7.224,0,0,1,15,7.5a7.224,7.224,0,0,1-2.2,5.3A7.224,7.224,0,0,1,7.5,15a7.224,7.224,0,0,1-5.3-2.2A7.224,7.224,0,0,1,0,7.5,7.224,7.224,0,0,1,2.2,2.2Zm5.97.479h-.8V7.366H4.018v.8H8.17Z" /></svg></div>
                                    <div className={classes.time}>
                                        {nextOrder ? nextOrder.reference : ''}
                                    </div>
                                </div>
                                <div className={classes.gradientSplitter}>
                                </div>
                                <div className={classes.nextOrderCode}>
                                    {nextOrder ? nextOrder.customerName : ''}
                                </div>
                            </Box>
                        </Box>

                        <div className={classes.middleBody}>
                            <OrderDetailMainInfo productionOrder={order} {...props}></OrderDetailMainInfo>
                        </div>

                        <div className={classes.lowerBody}>
                            <OrderDetailMaterials openManualReplenishmentDrawer={openManualReplenishmentDrawer} openMaterialCorrectionDrawer={openMaterialCorrectionDrawer} setUpdateQuantityAtMachine={setUpdateQuantityAtMachine} updateQuantityAtMachine={updateQuantityAtMachine} productionOrder={order} getQuantityAtMachine={getQuantityAtMachine} {...props}></OrderDetailMaterials>
                        </div>
                    </div>
                </div>
                <div className={classes.sideBar}>
                    {
                        zones !== undefined && zones !== null && zones.length > 0 && productionOrders !== undefined && productionOrders !== null && productionOrders.length > 0 && <OrderDetailStatusBar zones={zones} refreshOrder={updateOrderDetailPage} openStandstillPopup={openStandstillPopup} producedBOMOut={producedBOMOut} productionOrders={productionOrders} productionOrder={order}  {...props} actions={props.actions} openMachineParametersDrawer={openMachineParametersDrawer} openZoneDivisionPopupInput={openZoneDivisionPopupInput} openZoneDivisionPopup={openZoneDivisionPopup} quantitiesAssigned={quantitiesAssigned} hasZoneDivisions={hasZoneDivisions} getQuantityAtMachine={getQuantityAtMachine}></OrderDetailStatusBar>
                    }
                </div>
                {bookingFeedbackDialogOpen && <AlertDialog dialogOpen={bookingFeedbackDialogOpen} action={closeBookingFeedbackDialog} closeDialog={closeBookingFeedbackDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></AlertDialog>}
                {machineParametersDrawerOpen && <MachineParametersDrawer openDrawer={openMachineParametersDrawer} drawerOpen={machineParametersDrawerOpen} productionOrder={order} {...props}></MachineParametersDrawer>}
                {zoneDivisionPopupInputOpen && <ZoneDivisionPopupInput openZoneDivisionPopupInput={openZoneDivisionPopupInput} popupOpen={zoneDivisionPopupInputOpen} setReload={setReload} productionOrder={order} zoneDivisions={zoneDivisions} zoneDivisionsOrderLineId={zoneDivisionsOrderLineId} machineNumber={order.machinePlannedCode.match(/\d/g).join("")} {...props}></ZoneDivisionPopupInput>}
                {zoneDivisionPopupOpen && <ZoneDivisionPopup popupOpen={zoneDivisionPopupOpen} openZoneDivisionPopup={openZoneDivisionPopup} zoneDivisions={zoneDivisions} zoneDivisionsOrderLineId={zoneDivisionsOrderLineId} hasZoneDivisions={hasZoneDivisions} {...props}></ZoneDivisionPopup>}
                {materialCorrectionDrawerOpen && <MaterialCorrectionDrawer draweropen={materialCorrectionDrawerOpen} opendrawer={openMaterialCorrectionDrawer} quantitiesAssigned={quantitiesAssigned} productionOrder={order} openDeleteQuantitiesDialog={openDeleteQuantitiesDialog}></MaterialCorrectionDrawer>}
                {deleteQuantitiesDialogOpen && <DeleteDialog dialogOpen={deleteQuantitiesDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setDeleteQuantitiesDialogOpen(false)} action={() => deleteMaterialAssigned(quantityIdToRemove)}></DeleteDialog>}
                {manualReplenishmentDrawerOpen && <ManualReplenishmentDrawer draweropen={manualReplenishmentDrawerOpen} opendrawer={openManualReplenishmentDrawer} actions={props.actions} productionOrder={order} {...props} refreshQuantitiesAssigned={refreshQuantitiesAssigned}></ManualReplenishmentDrawer>}
                {standstillPopupOpen && <StandstillPopup dialogOpen={standstillPopupOpen} action={confirmStandstillDialog} closeDialog={closeStandstillDialog}></StandstillPopup>}
                {standstillCleaningPopupOpen && <StandstillCleaningPopup dialogOpen={standstillCleaningPopupOpen} action={confirmStandstillCleaningDialog} closeDialog={closeStandstillCleaningDialog}></StandstillCleaningPopup>}
                {standstillCleaningReasonPopupOpen && <StandstillCleaningReasonDrawer openDrawer={openStandstillCleaningReasonDialog} drawerOpen={standstillCleaningReasonPopupOpen} actions={props.actions} setStandstillCleaningReasonPopupOpen={setStandstillCleaningReasonPopupOpen} action={confirmStandstillCleaningReasonDialog} machineId={order.machineIdPlanned}></StandstillCleaningReasonDrawer>}
                {standstillTechnicalPopupOpen && <StandstillTechnicalReasonPopup dialogOpen={standstillTechnicalPopupOpen} action={confirmStandstillTechnicalDialog} closeDialog={closeStandstillTechnicalReasonDialog}></StandstillTechnicalReasonPopup>}

            </React.Fragment> : <React.Fragment></React.Fragment>}
        </div>
    )
}

const useStyles = makeStyles({
    header: {
        height: '100px',
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between"
    },
    title: {
        width: "50%",
        float: "left",
        height: "80px"
    },
    scissorStatus: {
        width: "50%",
        maxWidth: "350px",
        overflow: "hidden",
        float: "right",
        paddingTop: "5px",
        marginRight: "2.2%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: 'column',
    },
    body: {
    },
    orderNumber: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "5px",
        textWrap: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    background: {
        padding: "1.6%",
        paddingRight: "0px",
        paddingTop: "0px",
        position: "relative",
    },
    sideBar: {
        display: "flex",
        flexDirection: "column",
        width: "20%",
        float: "left",
        background: "linear-gradient(white, transparent);",
        height: "95%"
    },
    main: {
        width: "80%",
        float: "left"
    },
    upperBody: {
        width: "97.7%",
    },
    middleBody: {
        display: "block",
        backgroundColor: "white",
        height: "auto",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        marginTop: "10px",
        width: "97.7%",
        marginRight: "0.7%"
    },
    lowerBody: {
        display: "block",
        backgroundColor: "white",
        height: "auto",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        marginTop: "10px",
        width: "97.7%",
        marginRight: "0.7%"
    },
    progress: {
        height: "100px",
        width: "100%",
        backgroundColor: "white",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        borderRadius: "6px",
        float: "left",
        boxSizing: "border-box",
        marginRight: "0.7%",
        padding: "10px"
    },
    upNext: {
        height: "100px",
        width: "100%",
        border: "1px solid #DEDEDE",
        borderRadius: "6px",
        float: "left",
        boxSizing: "border-box",
        marginRight: "0.7%",
        padding: "10px"
    },
    productionProgress: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block",
        width: "100%",
        marginLeft: "3%",
        marginTop: "10px"

    },
    viewDetails: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        marginRight: "5px"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
    titleUpNext: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
    },
    viewDetailsButton: {
        float: "right"
    },
    upNextHeader: {
        display: 'block',
        height: "20px"
    },
    timeNextOrder: {
        display: 'block',
        height: "30px"
    },
    timeSvg: {
        float: "left",
        marginTop: "7px",
        marginRight: "5px"

    },
    time: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    gradientSplitter: {
        display: 'block',
        width: "100%",
        height: "7px",
        background: " transparent linear-gradient(90deg, #DEDEDE 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box;",
        marginTop: "3px",
        borderRadius: "5px"
    },
    nextOrderCode: {
        display: 'block',
        fontSize: "13px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        marginTop: '3px'
    },



});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
        workstation: state.workstation,
        machineStandStill: state.machineStandStill
    }
}

export default connect(mapStateToProps)(OrderDetailPage)